module.exports = __webpack_public_path__ + "img/interactive-prototype.db6cb897.png";